export const language = {
  en: {
    'Save': 'Save',
    'Please Entry': 'Please Entry',
    'Unified Social Credit Code': 'Unified Tax ID',
    'Company Basic Information': 'Company Basic Information',
    'Company Name': 'Company Name',
    'Company Name English': 'Company Name English',
    'Back': 'Back',
    'Name Type': 'Name Type',
    'ID': 'ID',
    'Name': 'Name',
    'Business License': 'Business License',
    'Please Upload': 'Please Upload',
    'Please Select': 'Please Select',
  },
  zh: {
    'Save': '申请',
    'Please Entry': '请输入',
    'Unified Social Credit Code': '统一社会信用代码',
    'Company Basic Information': '基本信息',
    'Company Name': '公司名称',
    'Company Name English': '公司名称(英文)',
    'Back': '返回',
    'Name Type': '公司类型',
    'ID': '身份证号',
    'Name': '姓名',
    'Business License': '营业执照',
    'Please Upload': '请上传',
    'Please Select': '请选择'
  }
};
